module.exports = __webpack_public_path__ + "img/209.blockage_toilet.920eba7d.svg";